import React from 'react';
import PropTypes from 'prop-types';

import { get } from 'dpl/shared/utils/object';
import ErrorWrapper from 'dpl/form/components/ErrorWrapper';
import FullPageQuizTextInput from 'dpl/components/FullPageQuiz/FullPageQuizTextInput';
import FullPageQuizQuestion from 'dpl/components/FullPageQuiz/FullPageQuizQuestion';

const INPUT_NAME = 'buyer_profile_attributes.address_attributes.postal_code';

export default function QuizZipcodeQuestion({
  formErrors,
  formState,
  onChange,
  handleNextClick,
  isValid
}) {
  const zipcode = get(formState, INPUT_NAME) || '';
  const errors = formErrors[INPUT_NAME] || [];

  return (
    <div className="AdoptionApplicationQuizZipcodeQuestion">
      <FullPageQuizQuestion
        handleNextClick={handleNextClick}
        icon="zipcode"
        isValid={isValid}
        subtitle="This helps your breeder plan for puppy pickup or drop-off."
        title="You're almost done! Enter your zip code."
      >
        <ErrorWrapper errors={errors}>
          <FullPageQuizTextInput
            className="mw-50"
            name={INPUT_NAME}
            onChange={onChange}
            type="text"
            value={zipcode}
            placeholder="Zip code"
          />
        </ErrorWrapper>
      </FullPageQuizQuestion>
    </div>
  );
}

QuizZipcodeQuestion.propTypes = {
  formErrors: PropTypes.object.isRequired,
  formState: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  handleNextClick: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired
};
